function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M214 630 c-86 -27 -180 -123 -204 -208 -15 -55 -12 -162 6 -215 29 -87 149 -193 207 -185 17 2 23 11 25 35 3 29 0 33 -20 33 -46 0 -69 13 -98 56 -34 50 -26 58 13 14 21 -24 35 -30 66 -30 28 0 40 5 45 17 3 10 9 24 12 31 4 7 -2 12 -16 12 -11 0 -38 9 -59 20 -61 30 -89 122 -56 180 8 14 14 44 15 68 0 45 12 52 53 30 12 -6 64 -11 117 -11 53 0 105 5 117 11 41 22 53 15 53 -30 1 -24 7 -54 15 -68 33 -58 5 -150 -56 -180 -21 -11 -47 -20 -59 -20 -21 0 -26 -10 -11 -26 6 -5 11 -38 13 -74 3 -58 5 -65 25 -68 60 -9 179 99 208 189 24 70 17 198 -13 256 -33 63 -74 105 -134 138 -46 25 -65 30 -143 32 -49 1 -104 -2 -121 -7z"
}));

const SvgGithubLogo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "64.000000pt",
  height: "20.000000pt",
  viewBox: "0 0 64.000000 64.000000",
  preserveAspectRatio: "xMidYMid meet",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGithubLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/github-logo.3134f8d5.svg";
export { ForwardRef as ReactComponent };